import { useState, useEffect } from 'react';

import axios from 'axios';
import routes from 'app/routes';

export default function usePlans({ enterpriseId }) {
  const [plans, setPlans] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.policy_plans.index, { params: { enterprise_id: enterpriseId } })
      .then((response) => {
        setPlans(response.data.data);
      });
  }, [enterpriseId]);

  return plans;
}
